import PropTypes from "prop-types";
import { createContext, useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import api from "api/api";

export const AuthContext = createContext();

export const AuthContextProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  // Check for token and set user on app load
  useEffect(() => {
    const token = localStorage.getItem("adminToken");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUser(decoded); // Set decoded user data
      } catch (err) {
        console.error("Token decode failed", err);
        setUser(null);
      }
    }
  }, []);

  // Login function - make API call here
  const loginUser = async ({ email, password }) => {
    try {
      const response = await api.post("admin/login", { email, password });
      const token = response.data.access_token;
      localStorage.setItem("adminToken", token);

      const decoded = jwtDecode(token);
      setUser(decoded);
    } catch (error) {
      console.error("Login failed", error);
      alert("Invalid email or password");
    }
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loginUser }}>{children}</AuthContext.Provider>
  );
};

// PropTypes validation
AuthContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
